import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { NotifyService } from '../../services/notification/notify.service';
import { ModuleAccessService } from '../../services/module-access.service';
import { PermissionUtils } from '../../utils/permission.utils';
import { AuthState } from '../../store/auth/auth.state';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root'
})
export class NotFoundGuard implements CanActivate {

  constructor(
    private router: Router,
    private moduleAccessService: ModuleAccessService,
    private permissionUtils: PermissionUtils,
    private store: Store,
    private notify: NotifyService
  ) {}

  canActivate(): boolean {
    const token = this.store.selectSnapshot(AuthState.getToken);

    if (!token) {
      this.router.navigateByUrl('/auth/login');
      return false;
    }

    const state = this.moduleAccessService.getCurrentState();

    // Priority: last visited module → first accessible module → module hub
    const redirectModule = state.currentModule ?? state.accessibleModules[0] ?? null;

    if (redirectModule) {
      const lastUrl = this.moduleAccessService.getLastModuleUrl(redirectModule);
      const moduleInfo = this.permissionUtils.getModuleInfo(redirectModule);
      this.notify.show({
        tipo: 'warn',
        titulo: 'Página no encontrada',
        desc: `La página que intentaste acceder no existe. Te redirigimos al módulo "${moduleInfo.name}".`,
        duracion: 5000,
      });
      // Use last visited URL (with filters) if available, otherwise module's base route
      if (lastUrl) {
        this.router.navigateByUrl(lastUrl);
      } else {
        this.router.navigate([moduleInfo.route]);
      }
      return false;
    }

    this.notify.show({
      tipo: 'warn',
      titulo: 'Página no encontrada',
      desc: 'La página que intentaste acceder no existe.',
      duracion: 4000,
    });
    this.router.navigate(['/modulos']);
    return false;
  }
}
